import clsx from 'clsx'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

import { Flex } from '@/components/layout/Flex'
import { Button, Dialog, InputRadioGroup } from '@/components/ui'
import i18n from '@/lib/i18n'
import { useLanguage } from '@/lib/i18n/hooks/useLanguage'
import { Language } from '@/lib/i18n/i18n'

import { LanguageChangeModalProps } from './type'

const schema = z.enum(['ja', 'en'])

export const LanguageChangeModal = ({
  isOpen,
  onClose,
}: LanguageChangeModalProps) => {
  const { t } = useTranslation()
  const { changeLanguage } = useLanguage()
  const [editingLanguage, setEditingLanguage] = useState<Language>(() => {
    const parsed = schema.safeParse(i18n.language)
    return parsed.success ? parsed.data : 'ja'
  })

  return (
    <Dialog title={t('user.language.title')} isOpen={isOpen}>
      <Flex center direction="column" className={clsx('tw-my-8')}>
        <p className={clsx('tw-mb-8 tw-text-sm')}>
          {t('user.language.message.confirm')}
        </p>
        <InputRadioGroup
          options={[
            { label: t('common.japanese'), value: 'ja' },
            { label: t('common.english'), value: 'en' },
          ]}
          selected={editingLanguage}
          handleChange={setEditingLanguage}
        />
      </Flex>
      <div className={clsx('tw-my-4 tw-grid tw-grid-cols-2 tw-gap-2 tw-px-2')}>
        <Button type="button" variant="normal" onClick={onClose}>
          {t('auth.email.close')}
        </Button>
        <Button
          type="button"
          variant="primary"
          onClick={() => {
            changeLanguage(editingLanguage)
            onClose()
          }}
        >
          {t('common.action.update')}
        </Button>
      </div>
    </Dialog>
  )
}
